module.exports = __webpack_public_path__ + "img/ic_24_dices.36952030.svg";